import { FC, ReactNode, useEffect, useState } from 'react'

import { observer } from 'mobx-react-lite'

import { setSettingForApp } from 'entities/user/module/app-settings'
import userStore from 'entities/user/module/user-store'

import { KyrgyzstanOnboarding } from './index'

interface OnboardingWrapperProps {
  children: ReactNode
  storageKey?: string
}

const DEFAULT_STORAGE_KEY = 'kyrgyzstan_onboarding_seen'

export const OnboardingWrapper: FC<OnboardingWrapperProps> = observer(
  ({ children, storageKey = DEFAULT_STORAGE_KEY }) => {
    const [showOnboarding, setShowOnboarding] = useState(false)

    useEffect(() => {
      if (!userStore.userSettings) return

      const hasSeenOnboarding = userStore.getClientStateString(storageKey)

      setShowOnboarding(!hasSeenOnboarding)
    }, [storageKey, userStore.userSettings, userStore.client_state])

    const handleClickOnboarding = () => {
      void setSettingForApp({ key: storageKey, value: 'seen' })
      setShowOnboarding(false)
    }

    if (showOnboarding) {
      return (
        <KyrgyzstanOnboarding
          onClose={handleClickOnboarding}
          onStart={handleClickOnboarding}
        />
      )
    }

    return <>{children}</>
  },
)
